import React, { useContext } from 'react';
import AppContext from '../Context/AppContext';
import {ParticipantContainer, Participant, SimpleText} from './style';

const Participants = () => {
    const { members } = useContext(AppContext);
    
    return (
      <ParticipantContainer>
        <SimpleText>Participants</SimpleText>
          {members.map(member => <Participant key={member}>- {member}</Participant>)}
      </ParticipantContainer>
    );
}

export default Participants;